import React from "react";
import "./panel.scss";
import { Addresses } from "utils/Addresses";

const Page404: React.FC = () => {
  return (
    <div className="page404-parent">
      <h1>SORRY</h1>
      <h2>We couldn't find that page</h2>
      <img src={Addresses.images.PAGE_404} alt="page 404" />
    </div>
  );
};

export default Page404;
